import { cellPaddingClassFor } from '@/lib/display-tweaks';
import { cn } from '@/lib/utils';
import { PreviewFrame } from './preview-frame';
import type { SettingPreviewProps } from './setting-preview-props';
import { SkeletonBar } from './skeleton-bar';

const BODY_ROWS = [0, 1, 2] as const;
const COLUMNS = [
  { header: 70, lines: [70, 85] },
  { header: 55, lines: [85, 55] },
  { header: 70, lines: [85, 40] },
] as const;

/** `matrix-cell-padding`: a small grid whose cells carry the real padding classes. */
export function CellPaddingPreview({ value }: SettingPreviewProps) {
  const padding = cellPaddingClassFor(value);
  const cell = cn('border-gray-100 border-r border-b text-left align-top font-normal', padding);
  return (
    <PreviewFrame>
      <table className="w-full table-fixed border-collapse">
        <thead>
          <tr>
            <th className={cn(cell, 'border-r-2 border-r-gray-200 bg-gray-50')} />
            {COLUMNS.map((column, index) => (
              // biome-ignore lint/suspicious/noArrayIndexKey: static fake data, never reordered
              <th key={index} className={cell}>
                <SkeletonBar width={column.header} />
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {BODY_ROWS.map((row) => (
            <tr key={row}>
              <th className={cn(cell, 'space-y-1 border-r-2 border-r-gray-200 bg-gray-50')}>
                <SkeletonBar width={85} />
                <SkeletonBar width={55} />
              </th>
              {COLUMNS.map((column, index) => (
                // biome-ignore lint/suspicious/noArrayIndexKey: static fake data, never reordered
                <td key={index} className={cn(cell, 'space-y-1')}>
                  <SkeletonBar width={column.lines[0]} />
                  <SkeletonBar width={column.lines[1]} />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </PreviewFrame>
  );
}
